import { useMesChambres } from '../../api/useMesChambres';
import EtatErreur from '../../components/EtatErreur';
import Text from '../../components/Text';
import { echecSansDonnee } from '../../helpers/requete';
import { t } from '../../i18n/langue';

import CarteChambre from './CarteChambre';

/**
 * Le planning de demain de l'agent — lot 3 Odomo, comme `TomorrowRooms` du web.
 *
 * En LECTURE SEULE : rien ne se démarre d'ici, donc les cartes ne sont pas des
 * contrôles. Pas de sondage non plus (`useMesChambres` ne sonde qu'aujourd'hui).
 */
interface ListeDemainProps {
    facilityId: number;
    date: string;
}

export default function ListeDemain({ facilityId, date }: ListeDemainProps) {
    const { data, isLoading, isError, refetch } = useMesChambres({ facilityId, date });
    const echec = echecSansDonnee({ isError, data });
    const chambres = data ?? [];

    if (isLoading) {
        return (
            <Text variante="petit" ton="attenue">
                {t('commun.chargement')}
            </Text>
        );
    }

    if (echec) return <EtatErreur onReessayer={() => void refetch()} />;

    return (
        <div className="flex flex-col gap-2">
            <div className="rounded-xl bg-main-color-light px-3 py-2">
                <Text variante="petit" ton="marque">
                    {t('menage.planningDemain')}
                </Text>
            </div>

            {chambres.length === 0 && (
                <Text variante="petit" ton="attenue">
                    {t('menage.rienDemain')}
                </Text>
            )}

            {chambres.map((chambre) => (
                <CarteChambre key={chambre.service_id} chambre={chambre} />
            ))}
        </div>
    );
}
